export const ACCOUNT_OPTIONS = {
  // TODO: need to determine what correct urls are
  PROFILE: {
    id: "settings",
    content: "Your Profile",
    url: "/account/settings",
  },
  CLASS: {
    id: "classes",
    content: "Your Classes",
    url: "/account/classes",
  },
  STUDENTS: {
    id: "students",
    content: "Your Students",
    url: "/account/students",
  },
  FACULTY: {
    id: "faculty",
    content: "Your Faculty",
    url: "/account/faculty",
  },
  // `id` must match the second path segment of `url` — useSidebarMenuOptions
  // derives the selected item from it.
  SUBSCRIPTIONS: {
    id: "subscriptions",
    content: "Your Subscriptions",
    url: "/account/subscriptions",
  },
};

const menuOptions = [
  {
    id: "account",
    title: "Settings",
    options: [
      {
        id: ACCOUNT_OPTIONS.PROFILE.id,
        content: ACCOUNT_OPTIONS.PROFILE.content,
        ariaLabel: ACCOUNT_OPTIONS.PROFILE.content,
        title: ACCOUNT_OPTIONS.PROFILE.content,
        url: ACCOUNT_OPTIONS.PROFILE.url,
      },
      {
        id: ACCOUNT_OPTIONS.CLASS.id,
        content: ACCOUNT_OPTIONS.CLASS.content,
        ariaLabel: ACCOUNT_OPTIONS.CLASS.content,
        title: ACCOUNT_OPTIONS.CLASS.content,
        url: ACCOUNT_OPTIONS.CLASS.url,
      },
      {
        id: ACCOUNT_OPTIONS.STUDENTS.id,
        content: ACCOUNT_OPTIONS.STUDENTS.content,
        ariaLabel: ACCOUNT_OPTIONS.STUDENTS.content,
        title: ACCOUNT_OPTIONS.STUDENTS.content,
        url: ACCOUNT_OPTIONS.STUDENTS.url,
      },
      {
        id: ACCOUNT_OPTIONS.FACULTY.id,
        content: ACCOUNT_OPTIONS.FACULTY.content,
        ariaLabel: ACCOUNT_OPTIONS.FACULTY.content,
        title: ACCOUNT_OPTIONS.FACULTY.content,
        url: ACCOUNT_OPTIONS.FACULTY.url,
      },
      {
        id: ACCOUNT_OPTIONS.SUBSCRIPTIONS.id,
        content: ACCOUNT_OPTIONS.SUBSCRIPTIONS.content,
        ariaLabel: ACCOUNT_OPTIONS.SUBSCRIPTIONS.content,
        title: ACCOUNT_OPTIONS.SUBSCRIPTIONS.content,
        url: ACCOUNT_OPTIONS.SUBSCRIPTIONS.url,
      },
    ],
  },
];

export const breadcrumbOptions = [
  {
    href: ACCOUNT_OPTIONS.PROFILE.url,
    contents: ACCOUNT_OPTIONS.PROFILE.content,
  },
  {
    href: ACCOUNT_OPTIONS.CLASS.url,
    contents: ACCOUNT_OPTIONS.CLASS.content,
  },
  {
    href: ACCOUNT_OPTIONS.STUDENTS.url,
    contents: ACCOUNT_OPTIONS.STUDENTS.content,
  },
  {
    href: ACCOUNT_OPTIONS.FACULTY.url,
    contents: ACCOUNT_OPTIONS.FACULTY.content,
  },
  {
    href: ACCOUNT_OPTIONS.SUBSCRIPTIONS.url,
    contents: ACCOUNT_OPTIONS.SUBSCRIPTIONS.content,
  },
];

export default menuOptions;
